// src/components/resources/quizzes/components/QuizHeader.tsx

'use client'

import type { QuizHeaderProps } from '~/components/resources/quizzes/types/quiz-types'

export function QuizHeader({
  currentSectionIndex,
  currentQuestionIndex,
  totalSections,
  questionsInSection,
  sectionTitle,
  questionsAnswered,
  totalQuestions
}: QuizHeaderProps): JSX.Element {
  const progress = (questionsAnswered / totalQuestions) * 100

  return (
    <div className="relative px-4 pt-4 sm:pt-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 sm:gap-0">
        <div>
          <p className="text-xs sm:text-sm font-medium text-gray-600 dark:text-gray-400">
            Section {currentSectionIndex + 1} of {totalSections}
          </p>
          <h2 className="mt-0.5 sm:mt-1 text-xl sm:text-2xl font-bold tracking-tight text-gray-900 dark:text-white line-clamp-2">
            {sectionTitle}
          </h2>
        </div>
        <div className="text-left sm:text-right">
          <p className="text-xs sm:text-sm font-medium text-gray-600 dark:text-gray-400">
            Question {currentQuestionIndex + 1} of {questionsInSection}
          </p>
          <p className="mt-0.5 sm:mt-1 text-xs sm:text-sm text-gray-500 dark:text-gray-400">
            {questionsAnswered} of {totalQuestions} total questions answered
          </p>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="relative mt-4 sm:mt-6">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-gray-200 dark:border-gray-700" />
        </div>
        <div className="relative flex justify-center">
          <div className="inline-flex items-center gap-x-1.5 rounded-full bg-white px-2.5 sm:px-3 py-1 sm:py-1.5 text-xs sm:text-sm font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 dark:bg-gray-800 dark:text-white dark:ring-gray-700">
            <span className="text-indigo-600 dark:text-indigo-400">{Math.round(progress)}%</span>
            <span className="text-gray-400 dark:text-gray-500">complete</span>
          </div>
        </div>
      </div>
    </div>
  )
} 